import { useState } from 'react';
import { DialogContent, Link } from '@material-ui/core';
import PropTypes from 'prop-types';

import { BlockCustomModelExtraction } from 'src/components/BlockCustomModelExtraction';
import { CustomDialog } from 'src/components/CustomDialog';
import { FieldCheckbox } from 'src/components/FieldCheckbox';
import { isBlogUrlsChannel } from 'src/data/channel';
import { getGenerationToolFromCustomModel } from 'src/data/customModel';
import { getToolTitle } from 'src/data/generationTool';
import { isEmailCsvResourceDocument } from 'src/data/performance';
import { formatNumber } from 'src/lib/format';
import { formatRoute } from 'src/lib/routing';
import { ROUTES } from 'src/routes';
import { useIsCustomerOnBusinessOrEnterprisePlan } from 'src/services';
import { useIsCurrentUserAdmin } from 'src/store';

import { useStyles } from './useStyles';

export const CustomModelSuccessPopup = ({ open, onClose, customModel }) => {
  const styles = useStyles();

  const [isDefault, setIsDefault] = useState(false);

  const isCurrentUserAdmin = useIsCurrentUserAdmin();

  const isCustomerOnBusinessOrEnterprisePlan = useIsCustomerOnBusinessOrEnterprisePlan();

  if (!customModel) {
    return null;
  }

  const displayUpgradeContainer =
    !isCustomerOnBusinessOrEnterprisePlan &&
    !isEmailCsvResourceDocument(customModel.dataSource) &&
    !isBlogUrlsChannel(customModel.dataSource);

  const toolTitle = getToolTitle(getGenerationToolFromCustomModel(customModel));

  return (
    <CustomDialog
      className={styles.root}
      open={open}
      fullWidth
      title="Custom model training complete!"
      data-testid="CustomModelSuccessPopup"
      onSubmit={() => onClose(isDefault)}
      submitLabel="Close"
    >
      <DialogContent className={styles.dialogContent}>
        <BlockCustomModelExtraction data={customModel} />

        {displayUpgradeContainer && (
          <div className={styles.upgradeContainer}>
            This custom model was trained on only {formatNumber(customModel.usedCopies)} of the{' '}
            {formatNumber(customModel.totalCopies)} assets that were available for training.
            <br />
            <Link href={formatRoute(ROUTES.UPGRADE)}>Upgrade to higher plan</Link> to train larger
            and more accurate models.
          </div>
        )}
        {isCurrentUserAdmin && (
          <FieldCheckbox
            className={styles.default}
            checked={isDefault}
            onChange={(event) => setIsDefault(event.target.checked)}
            label={`Set as default for ${toolTitle}`}
          />
        )}
      </DialogContent>
    </CustomDialog>
  );
};

CustomModelSuccessPopup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  customModel: PropTypes.shape({
    usedCopies: PropTypes.number,
    totalCopies: PropTypes.number,
  }).isRequired,
};
CustomModelSuccessPopup.defaultProps = {
  open: false,
};
